var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"d-flex align-items-center justify-content-between mx-auto"},[_vm._m(0),_c('div',[_c('img',{staticClass:"img-fluid client-logo",attrs:{"src":_vm.clientLogo,"alt":"client logo"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"img-fluid ced",attrs:{"src":require("@/assets/images/header/ced_logo.svg"),"alt":"ced"}})])
}]

export { render, staticRenderFns }